import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import '../Step.scss';

const Step1 = ({ data, onSubmit }) => {
  const [accountInfo, setAccountInfo] = useState(data);

  const handleChange = e => {
    setAccountInfo({
      ...accountInfo,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    onSubmit && onSubmit({ sectionStep: 'user', payload: accountInfo, nextStep: 2 });
  };

  const validForm = () => {
    return accountInfo?.given_name && accountInfo?.family_name && accountInfo?.email && accountInfo?.locale;
  };

  return (
    <div className="stepContainer">
      <div className="stepTitleContainer">
        <p className="stepText">Step 1</p>
        <h1 className="stepTitle">Account Information</h1>
      </div>

      <div className="stepFormContainer">
        <div className="stepFormGroup">
          <label htmlFor="given_name">First Name</label>
          <input
            onChange={handleChange}
            type="text"
            value={accountInfo?.given_name || ''}
            name="given_name"
            id="given_name"
            placeholder="Required"
            required
          />
        </div>
        <div className="stepFormGroup">
          <label htmlFor="family_name">Last Name</label>
          <input
            onChange={handleChange}
            type="text"
            value={accountInfo?.family_name || ''}
            name="family_name"
            id="family_name"
            placeholder="Required"
            required
          />
        </div>
        <div className="stepFormGroup">
          <label htmlFor="email">Email</label>
          <input
            onChange={handleChange}
            type="email"
            value={accountInfo?.email || ''}
            name="email"
            id="email"
            placeholder="Required"
            required
          />
        </div>
        <div className="stepFormGroup">
          <label htmlFor="locale">Phone</label>
          <InputMask
            mask="999-999-9999"
            placeholder="Required"
            value={accountInfo?.locale || ''}
            name="locale"
            id="locale"
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="stepTitleContainer">
        <p className="stepText">By continuing, you accept our</p>
        <div className="termsAndCondition">
          <a href="https://www.wrkfloz.net/_files/ugd/d8f992_b7593d655b9d43dca0a39fe1007ca474.pdf">Terms and conditions & Privacy Policy</a>
        </div>
      </div>

      <button className="stepNextButton" disabled={!validForm()} onClick={handleSubmit}>
        Next Step
      </button>
    </div>
  );
};

export default Step1;
